/**
 * Gene-set cart (KC) factorization limits — not used by Multi Query REVEAL.
 */

const GENE_SET_CART_2KC_BUILD_OPTIONS = {
    maxGenesPerFactor: 100,
    maxGeneSetsPerFactor: 100,
    maxGeneSetPValue: 0.05,
    minGeneFactorValue: 0.2,
};

export { GENE_SET_CART_2KC_BUILD_OPTIONS };
